/* Publish by EComposer at 2026-09-28 10:30:43*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-17oheywc6ydh"]=  window.__ectimmers["ecom-17oheywc6ydh"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-17oheywc6ydh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-17oheywc6ydh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8myk4j5cfcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8myk4j5cfcv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-heztb28jh3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-heztb28jh3a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3zwuvvv0foo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3zwuvvv0foo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8yeoqsp0ho3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8yeoqsp0ho3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zw5pn2kpl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zw5pn2kpl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewepqij3sp9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewepqij3sp9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nelb1vajiyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nelb1vajiyi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p32n5zv97qr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p32n5zv97qr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1broqdy3gqx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1broqdy3gqx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8vl1rennmzr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vl1rennmzr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xpd7da54t6c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xpd7da54t6c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f22jhjeg9cd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f22jhjeg9cd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xbgyma4wqk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xbgyma4wqk8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qxpmqorbio8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxpmqorbio8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hu7ojq4gy4e"]=  window.__ectimmers["ecom-hu7ojq4gy4e"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-hu7ojq4gy4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hu7ojq4gy4e', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j1qpmm63xnp"]=  window.__ectimmers["ecom-j1qpmm63xnp"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-j1qpmm63xnp"]["9umglk4fp"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-j1qpmm63xnp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j1qpmm63xnp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4sn7xe61p5n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4sn7xe61p5n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jw3skeb927').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jw3skeb927', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whpnmjixsir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whpnmjixsir', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4trlgeuagml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4trlgeuagml', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9nk2lf1oti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9nk2lf1oti', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g3ocqdl8gd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g3ocqdl8gd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rd572dnt078').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rd572dnt078', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-azc7skoo51h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-azc7skoo51h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gyq861bk9kp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gyq861bk9kp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zfnwylkoej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zfnwylkoej', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7md1cmbbay9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7md1cmbbay9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k14kqte4mb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k14kqte4mb', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cjmjzkqzbeq"]=  window.__ectimmers["ecom-cjmjzkqzbeq"] || {};
const t=this.$el;if(!t)return;const e=t.querySelector(".ec_splide");if(!e)return;const i=JSON.parse(e.dataset.ecSplideOption||"{}");!this.isLive&&i.type==="loop"&&(i.type="slide");const n=t.querySelector(".ecom-autoplay-progress svg"),o=t.querySelector(".ecom-autoplay-progress span"),r=t.querySelector(".ec_splide__pagination").getAttribute("data-pagination")=="true",a=window.innerWidth,l=this.settings.imageHeight,c=this.settings.imageHeight__mobile,d=this.settings.imageHeight__tablet,m=this.settings.content_animation,g=this.settings.slider_autoplay_speed,_={pagination:r};if(window.EcSplide){let v=function(){if(y)return;b=new EcSplide(e,Object.assign(_,i)),m&&(b.on("visible",function(C){setTimeout(C.slide.classList.add("ec_not_animation"),300)}),b.on("hidden",function(C){C.slide.classList.remove("ec_not_animation")})),_.pagination&&_.paginationType==="number"&&b.on("pagination:mounted",function(C){C.list.classList.add("splide__pagination--custom"),C.items.forEach(function(I){I.button.textContent=String(I.page+1)})});let $=b.root.querySelector(".ec_splide__progress__paginate");b.on("mounted move",function(){let C=b.Components.Controller.getEnd()+1,I=Math.min((b.index+1)/C,1);$.style.width=String(100*I)+"%"}),b.on("mounted",function(){setTimeout(()=>{b.refresh(),e.classList.remove("ec-slider-hidden"),e.classList.add("ec-slider-ready")},300)}),b.on("ready",function(){const C=["adapt_to_first_image"];(C.includes(l)||a<768&&C.includes(c)||a<1025&&a>767&&C.includes(d))&&k()}),b.options.autoplay&&n&&o&&z(b,1),b.on("autoplay:play",()=>{n&&o&&(n.style.setProperty("--progress",1),o.textContent=`${Math.ceil(g/1e3)}s`)});function z(C,I=0){if(n&&o&&(n.style.setProperty("--progress",I),C.Components.Autoplay)){const j=C.options.interval*(1-I);o.textContent=`${Math.ceil(j/1e3)}s`}}b.on("autoplay:playing",C=>{z(b,C)}),b.on("move",()=>{z(b,0)}),b.mount(),y=!0,e.ec_splide=b;const E=["adapt_to_image"];(E.includes(l)||a<768&&E.includes(c)||a<1025&&a>767&&E.includes(d))&&(w(),b.on("move resize",w))},w=function($){if(b.Components&&b.Components.Slides){let z=b.Components.Slides.getAt(typeof $=="number"?$:b.index).slide;z.parentElement.parentElement.style.height=z.querySelector("img").offsetHeight+"px"}},k=function(){const $=e.querySelector(".ec_splide__slide.is-active.is-visible img");if($){let z;$.complete?(z=$.offsetHeight,b.options={height:z+"px"}):$.addEventListener("load",function(){z=this.offsetHeight,b.options={height:z+"px"}})}},b=null,y=!1;v()}

                    });
                    
                        document.querySelectorAll('.ecom-cjmjzkqzbeq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjmjzkqzbeq', settings: {"imageHeight":"fixed_height","content_animation":"none","slider_autoplay_speed":6000},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mqutle4t3u"]=  window.__ectimmers["ecom-mqutle4t3u"] || {};
if(!this.$el||!window.EComModal)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&t&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-mqutle4t3u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mqutle4t3u', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}